import React, { useCallback, useState } from 'react'
import clsx from 'classnames'
import { APIService } from 'api/APIService'
import { cleanPhone } from 'utils/cleanPhone'
import { ShadowInput } from 'components/FormElements/ShadowInput/ShadowInput'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { StatusModal } from 'components/Utility/StatusModal/StatusModal'
import { usePhoneField } from '../usePhoneField'
import formStyles from './RecoveryForm.module.scss'
import styles from '../Form.module.scss'

type RecoveryFormProps = {
  /** The phone as typed, with the mask */
  onSubmit: (form: { phone: string }) => void,
}

/** Recovery step 1: the phone of an existing client */
export const RecoveryForm: React.FC<RecoveryFormProps> = ({ onSubmit }) => {
  const [formError, setFormError] = useState<string | null>(null)
  const [isLoading, setLoading] = useState(false)
  const [phone, setPhone] = useState('')
  const phoneField = usePhoneField(phone, setPhone)

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault()
    if (!cleanPhone(phone)) {
      setFormError('Не указан номер телефона')
      return
    }
    setLoading(true)
    try {
      await APIService.auth.checkClient(cleanPhone(phone))
      setLoading(false)
      onSubmit({ phone })
    } catch (err) {
      setFormError((err as Error).message)
      setLoading(false)
    }
  }, [phone, onSubmit])

  const dismissError = useCallback(() => setFormError(null), [])

  return (
    <form noValidate onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.fields}>
        <ShadowInput
          {...phoneField}
          className={styles.field}
          shadowColor={'satin'}
          placeholder={'Телефон'}
        />
      </div>
      <div className={styles.actions}>
        <AppButton type={'submit'} className={clsx([styles.action, formStyles.action])} disabled={isLoading}>
          Восстановить пароль
        </AppButton>
      </div>
      <StatusModal
        status={'error'}
        modalText={formError}
        buttonText={'ОК'}
        onClose={dismissError}
        onButtonClick={dismissError}
        isOpen={formError !== null}
      />
    </form>
  )
}
